import { z } from 'zod/v4';

import { normalizeTextWidgetArgs } from './text-widget-args.normalization';
import { partialTextWidgetDataSchema } from './partial-text-widget-data.schema';

/**
 * `data` is the same shared partial `create_text_widget` uses (minus create's required-`content`
 * tightening), kept deliberately identical so a model that has just seen its own create call in
 * the conversation history can pattern-match straight onto this tool — the same reasoning behind
 * `update_button_widget` reusing `partialButtonItemSchema`.
 */
const updateTextWidgetObjectSchema = z.object({
    widgetId: z.string().describe('Id of the text widget to update.'),
    data: partialTextWidgetDataSchema.describe(
        'Partial patch — only the fields you provide are changed, everything else on the widget is left as-is.'
    ),
});

export const updateTextWidgetArgsSchema = z.preprocess(normalizeTextWidgetArgs, updateTextWidgetObjectSchema);
